module.exports = __webpack_public_path__ + "static/media/tourism-boards-1.0af05d85.jpg";